import React, { Component } from 'react';

import { Logo, Button } from '../util';

import '../App.css';

/**
 * @prop runAppHandler
 */
export default class ReleaseNote extends React.Component {

  constructor (props) {
    super(props);


  }


  render() {
    return (
      <div>
        <header className="App-header">
        <div id="logo">
          <div onClick={this.props.openDashboardHandler}>
            <h1 style={{fontSize: '2.3em', position: 'relative', bottom: '.8em', textShadow: 'none'}}>Diary</h1>
          </div>
        </div> 
        </header>

        <article>
          <h1>
            Release Notes
          </h1>

          <ul>
            <li><b>May 26 2018</b> First release.</li>
            <li><b>May 29 2018</b> Fixed date localization.</li>
            <li><b>May 31 2018</b> <p>Set the title clickable.</p> <p>Fixed searching bug.</p></li>
          </ul>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page/ReleaseNote.js